var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3826",
    "data-name": "Group 3826",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.561,
    height: 19.334,
    viewBox: "0 0 18.561 19.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-user",
    transform: "translate(0 0.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5290",
    "data-name": "Path 5290",
    d: "M10.64,9.281A4.64,4.64,0,1,0,6,4.64a4.64,4.64,0,0,0,4.64,4.64Zm0-7.734A3.094,3.094,0,1,1,7.547,4.64,3.094,3.094,0,0,1,10.64,1.547Z",
    transform: "translate(-3.68)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5291",
    "data-name": "Path 5291",
    d: "M9.96,14A6.968,6.968,0,0,0,3,20.96a.773.773,0,1,0,1.547,0,5.414,5.414,0,1,1,10.827,0,.773.773,0,0,0,1.547,0A6.968,6.968,0,0,0,9.96,14Z",
    transform: "translate(-3 -3.173)",
    fill: "#bbc6d1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_21",
    "data-name": "Subtraction 21",
    d: "M7.72,17.787a.735.735,0,0,1-.729-.74,5.181,5.181,0,0,0-4.426-5.142A6.577,6.577,0,0,0,.776,10.471a6.5,6.5,0,0,1,5.747,1.862,6.685,6.685,0,0,1,1.928,4.715A.736.736,0,0,1,7.72,17.787ZM1.877,8.893a4.353,4.353,0,0,1-.453-.024A6.844,6.844,0,0,0,2,7.409,2.937,2.937,0,0,0,4.8,4.447,2.947,2.947,0,0,0,1.877,1.482a2.868,2.868,0,0,0-.841.125A6.59,6.59,0,0,0,0,.427,4.289,4.289,0,0,1,1.877,0,4.42,4.42,0,0,1,6.26,4.447,4.42,4.42,0,0,1,1.877,8.893Z",
    transform: "translate(10.111)",
    fill: "#bbc6d1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/adult.d73d45fc.svg";
export { ForwardRef as ReactComponent };